export const variableName = {
    outerHeaderName: 'PROSUSHIL LIFECARE LLP',
    outer: {
        footerName: 'PROSUSHIL LIFECARE LLP',
        address: [
            // "M.No.172000629, 17 / 438 / 3 / 1, Meena Mall, Near Panchavati Talkies",
            // "ICHALKARANJI - 416 115. Tal.Hatkanangale, Dist.Kolhapur.",
            // "E - Mail : prosushillifecarellp@gmail.com",
            // "Upper Basement Floor, C.S.No. 632/9A/640/638/638/35C",
            "UDYAM REGISTRATION NUMBER : UDYAM-MH-15-0118478",
            "D.L.No. : 20B/437339, 21B/437340, 20D/437342",
            "&nbsp; K-21/437338, K-20/437337, K-20C/437341",
            "GSTIN : 27ABAFP1524B1ZU"
        ],
        right: {
            liContent: [
                "BANK Details",
                "A/c No.",
                "IFSC CODE ",
            ]
        },
        end: [
            "ICICI BANK ",
            "777705619999 ",
            "ICIC0006973 ",
        ]
    },
    customerPhone: '9423275276',
    relyPhone: '7620789789',
};